import { formatters, useTranslation } from "@equiem/web-ng-lib";
import React from "react";

interface Session {
  startDate: number;
  duration: number;
  /** Server-formatted as `Session name. Location.`, so never append the location again. */
  displayName: string;
  timezone: string;
}

interface Props {
  /**
   * Structurally typed rather than derived from a generated query type: this
   * component is shared by the bookable product page and the cart, whose
   * queries select a different set of fields per session.
   */
  session: Session;
  showDate?: boolean;
}

/** A session's start time and duration, e.g. `10:00 AM, 1 hour.` */
export const SessionTime: React.FC<Props> = ({ session, showDate = false }) => {
  const { i18n } = useTranslation();
  const { startDate, duration, timezone } = session;

  const datePrefix = showDate
    ? `${formatters.datelong(startDate, i18n.language, { timezone })} @ `
    : "";
  const time = formatters.timeshort(startDate, i18n.language, { timezone });

  return (
    <>{`${datePrefix}${time}, ${formatters.durationshort(duration, i18n.language)}.`}</>
  );
};

/**
 * Renders a session as `10:00 AM, 1 hour. Session name. Location.`, with the
 * time and duration emphasised.
 *
 * The session card splits these two halves across separate lines and so uses
 * `SessionTime` and `displayName` directly; this inline form is what the
 * cart shows.
 */
export const ProductBookableItem: React.FC<Props> = ({ session, showDate = false }) => (
  <>
    <span style={{ fontWeight: 500 }}>
      <SessionTime session={session} showDate={showDate} />
    </span>{" "}
    {session.displayName}
  </>
);
